export default __webpack_public_path__ + "static/media/service-icon-1.d64b923b.png";